import {RefObject} from 'react'

import {getScrollBehavior} from './scrollBehavior'

export const scrollIntoView = (ref: RefObject<HTMLDivElement>, offset: number) => {
  if (ref.current) {
    const section = ref.current
    const {top, bottom} = section.getBoundingClientRect()
    const windowHeight = window.innerHeight

    // check if the section is fully visible
    if (top < offset) {
      // if the section is above the viewport, scroll up
      window.scrollTo({
        top: window.scrollY + top - offset,
        behavior: getScrollBehavior(),
      })
    } else if (bottom > windowHeight) {
      // if the section is below the viewport, scroll down
      window.scrollTo({
        top: window.scrollY + bottom - windowHeight + offset,
        behavior: getScrollBehavior(),
      })
    }
  }
}
